import React, { forwardRef } from "react";

import { Server } from "@modules/api";

import { ContentPageElement } from "../types";
import { compareContent } from "../helpers/comparers";

export function createPageElement<
  TExtraProps = {
    onPageLoading?: (
      pageData: Server.CollectionComponentDetailsOutput | undefined,
      isLoading: boolean
    ) => void;
  },
>(page: ContentPageElement<TExtraProps>) {
  return React.memo(forwardRef(page), (prevProps, nextProps) => {
    // console.log(
    //   "createComponentElement",
    //   prevProps.component.id === nextProps.component.id &&
    //     prevProps.context?.id === nextProps.context?.id
    // );
    const prevExtraProps = (
      Object.keys(prevProps) as [keyof typeof prevProps]
    ).filter((key) => key !== "component" && key !== "context");
    const nextExtraProps = (
      Object.keys(nextProps) as [keyof typeof nextProps]
    ).filter((key) => key !== "component" && key !== "context");
    if (prevExtraProps.length !== nextExtraProps.length) {
      console.log("ExtraProps length createPageElement changed.");
      return false;
    }
    for (const key of prevExtraProps) {
      if (prevProps[key] !== nextProps[key]) {
        console.log(`ExtraProp ${key.toString()} createPageElement changed.`);
        return false;
      }
    }

    const contentEqual = compareContent(prevProps.context, nextProps.context);
    if (!contentEqual) {
      console.log("Context props createPageElement changed.");
      return false;
    }

    return true;
  });
}
